import axios from "../../config/axios"

function create(data) {
    return axios().post("/fleet/models", data)    
}

function get(id) {
    return axios().get(`/fleet/models/${id}`)    
}

function update(id, data) {
    return axios().put(`/fleet/models/${id}`, data)
}

function remove(id) {
    return axios().delete(`/fleet/models/${id}`)
}

/**
 * 
 * @param {Number} brandID The brand id to list the models for
 * @returns {Promise}
 */
function listByBrand(brandID) {
    return axios().get(`/fleet/brands/${brandID}/models`)
}

export default {
    create,
    get,
    update,
    remove,
    listByBrand
}